export class Queue<T> {
    private _data: T[] = [];
    private readonly _queueSize;

    constructor(queueSize: number) {
        this._queueSize = queueSize;
    }

    get array() {
        return this._data;
    }

    get length() {
        return this._data.length;
    }

    at(index: number) {
        return this._data.at(index);
    }

    pop() {
        return this._data.shift();
    }

    front() {
        return this._data[0];
    }

    push(stat: T) {
        this._data.push(stat);
        if (this._data.length >= this._queueSize) {
            this._data.shift();
        }
    }

    clear() {
        this._data.splice(0);
    }
}
